"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MfaRecoveryCodeChallengeRequestSchema () {
        return MfaRecoveryCodeChallengeRequestSchema;
    },
    get MfaRecoveryCodeChallengeResponseSchema () {
        return MfaRecoveryCodeChallengeResponseSchema;
    }
});
const _zod = require("zod");
const _tokenpair = require("./token-pair");
const MfaRecoveryCodeChallengeRequestSchema = _zod.z.object({
    mfaToken: _zod.z.string().min(20),
    code: _zod.z.string().min(10).max(11).regex(/^[A-Za-z0-9-]+$/)
});
const MfaRecoveryCodeChallengeResponseSchema = _tokenpair.TokenPairSchema;
